
(function () {
    "use strict";

    angular.module("app").component("habilPdfViewer", {
        bindings: { document: "<", },
        controller: HabilPdfViewerController,
        template: `
        <div ng-if="$ctrl.browserSupportsPdf">
            <embed ng-src="{{$ctrl.previewUrl}}"
                   type="application/pdf"
                   width="100%"
                   height="600">
        </div>

        <div class="alert alert-warning" ng-if="!$ctrl.browserSupportsPdf">
            Your browser does not seem to support PDF files or it is disabled in the settings by your IT administrator.
            <br />
            <br />
            <a href="" habil-file-download="$ctrl.document"><i class="fa fa-download"></i> Download the file instead</a>
        </div>`,
    });

    HabilPdfViewerController.$inject = ["$sce", "base64Service",];
    function HabilPdfViewerController($sce, base64Service) {
        const vm = this;

        vm.$onChanges = function () {
            if (!vm.document || !vm.document.Content) {
                return;
            }

            const arrayBuffer = base64Service.toArrayBuffer(vm.document.Content);

            vm.downloadUrl = URL.createObjectURL(new Blob([arrayBuffer], { type: "application/pdf" }));
            // eslint-disable-next-line no-restricted-syntax
            vm.previewUrl = $sce.trustAsResourceUrl(`${vm.downloadUrl}#toolbar=0&navpane=0`);

            vm.browserSupportsPdf = navigator.pdfViewerEnabled || false;
        };

        vm.$onDestroy = function () {
            if (vm.downloadUrl) {
                URL.revokeObjectURL(vm.downloadUrl);
            }
        };
    }
})();
